import React from 'react';
import { setMainHeader } from 'hb-redux-store/initial.action';
import { connect } from 'react-redux';
import {
  getBlogBySlug,
  getBlogsByCategory,
} from 'hb-redux-store/feature/blog/blog.action';
import './blog.scss';
import Loader from '../../mweb/Skeletons/Loader/Loader';
import WebFooter from '../footer';
import MwebFooter from '../../mweb/Footer/Footer';
import { Helmet } from 'react-helmet';
import { getDeviceType } from '../../../hb-redux-store/util/DeviceDetectionService';
import { DEVICE_TYPE } from '../../../hb-redux-store/util/constantServices';
import BlogNav from './BlogNav';
import Icon from '../../mweb/Icon/Icon';
import { Link } from 'react-router-dom';
import AnalyticsService from 'AnalyticsService';

class Blog extends React.Component {
  componentDidMount() {
    const deviceType = getDeviceType();
    this.isDesktop = deviceType === DEVICE_TYPE.DESKTOP;
    if (this.isDesktop) this.props.setMainHeader(false);

    const originalSlug = this.props.match.params?.slug;
    const slug = originalSlug.substr(0, originalSlug.length - 3);
    // console.log('Slug: ', originalSlug, slug);
    this.props.getBlogBySlug({ slug, successOpCb: this.successOpCb });
  }

  componentWillUnmount() {
    if (this.isDesktop) this.props.setMainHeader(true);
  }

  successOpCb = ({ blogId, name, keywords }) => {
    // Clevertap Analytics
    const key = 'View Blog';
    const payload = {
      blogId,
      name,
      keywords,
    };
    AnalyticsService.clevertap.sendCleverTapEvent(key, payload);
  };

  render() {
    const { loading, blog } = this.props;
    const hashTagDelimiter = '&!~/';
    // console.log('Loading: ', loading);
    // console.log('blog: ', blog);

    return (
      <div className="blog">
        {loading && <Loader />}
        {!loading && blog && blog === 'invalid url' && (
          <React.Fragment>
            {!this.isDesktop && <BlogNav />}
            <div className="blog--empty">
              <Icon
                class="icon-empty-offers blog--empty--illustration"
                width={180}
                height={133}
              />
              <div className="blog--empty--description">
                The link you have visited is invalid.
                <br />
                Please check the link or view all the blogs.
              </div>
              <Link to="/blogs" className="button button-primary">
                View Blogs
              </Link>
            </div>
          </React.Fragment>
        )}
        {!loading && blog && blog !== 'invalid url' && (
          <div className="blog--content">
            <Helmet>
              <title>{blog.pageTitle}</title>
              <meta name="description" content={blog.description} />
              <meta name="keywords" content={blog.keywords} />
              <link rel="canonical" href={blog.canonicalUrl} />
              {/*  Twitter Card data  */}
              <meta name="twitter:card" value={blog.description} />
              {/*  Open Graph data  */}
              <meta property="og:title" content={blog.pageTitle} />
              <meta property="og:image" content={blog.imageUrl} />
              <meta property="og:description" content={blog.description} />
            </Helmet>
            {!this.isDesktop && <BlogNav />}
            <div className="blog--content--hero-image">
              <img
                alt={blog.heroImageAltText || blog.header}
                src={blog.imageUrl}
              />
            </div>
            <div className="blog--content--html">
              <div className="blog-title">{blog.name}</div>
              <div
                className="blog-html"
                dangerouslySetInnerHTML={{ __html: blog.htmlContent }}
              />
              {blog?.hashTags && (
                <React.Fragment>
                  <div className="section-divider" />
                  <div className="blog--content--hashtags">
                    Related tags:
                    <div>
                      {blog.hashTags.split(hashTagDelimiter).map((tag, i) => {
                        if (!tag) return null;
                        return (
                          <div className="blog--content--tag" key={i}>
                            {tag}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </React.Fragment>
              )}
            </div>
            {this.isDesktop ? <WebFooter /> : <MwebFooter />}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ blogReducer }) => ({
  loading: blogReducer.loading,
  allBlogs: blogReducer.allBlogs,
  blog: blogReducer.blog,
});
const mapDispatchToProps = {
  setMainHeader,
  getBlogBySlug,
  getBlogsByCategory,
};

export default connect(mapStateToProps, mapDispatchToProps)(Blog);
